// 시연용 식단 기록 로컬 스토리지 — 추후 서버 연동 시 교체.
// key = `iitp.foodrecord.<YYYY-MM-DD>.<mealType>`
// value = { images: [...], items: [...] }

const KEY_PREFIX = 'iitp.foodrecord.';
const KEY = (date, meal) => `${KEY_PREFIX}${date}.${meal}`;

// 모든 식단 기록 일괄 삭제 (시연 초기화용) — localStorage + IndexedDB 양쪽
export const clearAllMeals = async () => {
    const toRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k && k.startsWith(KEY_PREFIX)) toRemove.push(k);
    }
    toRemove.forEach((k) => localStorage.removeItem(k));
    try {
        const { clearImages } = await import('./imageStore');
        await clearImages();
    } catch {}
};

export const loadMeal = (date, meal) => {
    try {
        const raw = localStorage.getItem(KEY(date, meal));
        if (!raw) return { images: [], items: [] };
        const parsed = JSON.parse(raw);
        return {
            images: Array.isArray(parsed.images) ? parsed.images : [],
            items: Array.isArray(parsed.items) ? parsed.items : [],
        };
    } catch {
        return { images: [], items: [] };
    }
};

export const saveMeal = (date, meal, data) => {
    const empty = (!data?.images?.length) && (!data?.items?.length);
    if (empty) {
        try { localStorage.removeItem(KEY(date, meal)); } catch {}
        return;
    }
    // 이제 images 는 { key, labels } 만 들어있어 메타데이터만 작음 → quota 거의 안 터짐
    try {
        localStorage.setItem(KEY(date, meal), JSON.stringify(data));
    } catch (e) {
        console.error('[mealStorage] save failed', e?.message);
    }
};

export const hasMealData = (date, meal) => {
    const d = loadMeal(date, meal);
    return d.images.length > 0 || d.items.length > 0;
};

// 부동소수점 합 반올림 (1자리 소수)
const round1 = (n) => Math.round(n * 10) / 10;

export const summarizeMeal = (data) => {
    if (!data?.items?.length) return null;
    const menu = data.items.map((i) => i.name).join(', ');
    const sum = (k) => data.items.reduce((a, i) => a + (Number(i[k]) || 0), 0);
    return {
        menu,
        kcal: Math.round(sum('kcal')),
        sodium: Math.round(sum('sodium')),
        protein: round1(sum('protein')),
    };
};

